define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,def,Field,Relationship,Widget,xml,Query) {

return declare(Widget,
	{
		_resolveView: function() {
			// summary: add field for material type if on create form
			if (!this.getViewNode()) {
				var	fName = this.defView.getField(xml.ATTR_NAME);
				if (fName) {
					fName.idParameter = "Name";
					fName.m_dependency = "ProductStructureType";
				}
				
				this.insertField(lang.mixin(new Field(), {
					idParameter: "ToolURL",
					m_bRequired: true,
					m_label: "ProductStructureType",
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: "MaterialType",
						m_query: new Query()
							.Attr("Available", xml.OP_EQUALS, true, "Child:ProductionConfig")
							.Attr("MaterialUsage", xml.OP_EQUALS, "MaterialUsage:Tool", "Child:ProductionConfig")
					})
				}), 0);
			}

			this.inherited(arguments);
		}
	}
);
});